module.exports = __webpack_public_path__ + "static/media/tekura1.d0f569f7.jpg";